import { isScheduledStatus } from '@common/scheduling/status-scheduling';

/** What a send IS: 'status' is a scheduled WhatsApp Status post (the 24-hour
 *  story), not a message to a person. */
export type GlyphKind = 'message' | 'poll' | 'campaign' | 'status';

interface SendLike {
    isCampaign?: boolean | null;
    isPoll?: boolean | null;
    contactList?: ReadonlyArray<{ id?: string | null } | null | undefined> | null;
}

/**
 * The ONE decision the calendar chip and the planner's sidebar row both make,
 * so a send cannot be a Status on one surface and a message on the other.
 *
 * A Status is told apart by its RECIPIENT, `status@broadcast`, through the same
 * `isScheduledStatus` the send thunk uses to decide it posts to Status rather
 * than to a chat — so the planner calls a thing a Status exactly when the engine
 * will treat it as one. There is no separate flag on the document: the compose
 * toggle stores nothing but that recipient. The display name stored beside it
 * ('My Status', in English, written at compose time) is deliberately NOT the
 * signal.
 *
 * It outranks `isPoll` because the engine does: a Status is posted as a Status
 * whatever else is on the document. A campaign has no contact list, so it can
 * never be one.
 */
export function sendKindOf(send: SendLike | null | undefined): GlyphKind {
    if (!send) return 'message';
    if (send.isCampaign) return 'campaign';
    if (isScheduledStatus({ contactList: send.contactList ?? undefined } as Parameters<typeof isScheduledStatus>[0])) return 'status';
    return send.isPoll ? 'poll' : 'message';
}
